import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import Cards from 'components/Cards';
import TypeCard from 'components/Cards/TypeCard';
import selectTypeImage0 from 'assets/images/note-modal-0.jpeg';
import selectTypeImage1 from 'assets/images/note-modal-1.jpeg';

const CreateQuickNoteTemplate = ({ type, updateType, openCreateTemplateSettings, setModalSize }) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const project = useSelector((state) => state.projectTools.project);
  const { orgId: userOrgId } = userInfo;
  const { organizationId: projectOrgId } = project;
  const bottomRef = useRef(null);

  const canCreateFromTemplate = userOrgId === projectOrgId;

  if (!canCreateFromTemplate) {
    setModalSize('small');
  }

  useEffect(() => {
    if (type !== -1) bottomRef.current?.scrollIntoView({ bottomRef: 'smooth' });
  }, [type]);

  const handleTemplateCreateValidation = () => {
    if (type === -1) {
      return false;
    }
    return true;
  };

  const handleTemplateCreate = () => {
    if (handleTemplateCreateValidation()) {
      openCreateTemplateSettings();
    }
  };

  const desc1 = 'Create a shortcut template to link any resource across the web.';
  const desc2 = 'Create a new note template from scratch.';

  return (
    <>
      <h4 className="cards-container__subtitle">
        Select a note type
      </h4>
      <Cards>
        <TypeCard
          selected={type === 0}
          name="new-note"
          title="Shortcut"
          desc={desc1}
          img={{
            imgUrl: selectTypeImage0,
            alt: 'Shortcut',
          }}
          onClick={() => updateType(0)}
        />
        <TypeCard
          selected={type === 1}
          name="new-note"
          title="Note"
          desc={desc2}
          img={{
            imgUrl: selectTypeImage1,
            alt: 'Note',
          }}
          onClick={() => updateType(1)}
        />
      </Cards>
      <button
        className={clsx('button', type === -1 && 'button--not-allowed')}
        onClick={handleTemplateCreate}
      >
        Create new template
      </button>
      <div ref={bottomRef} />
    </>
  );
};

export default CreateQuickNoteTemplate;
